let scheduled = false;

/**
 * Has the Bloomreach app bind its click tracking to `[data-blm-add-to-cart]`
 * and `[data-blm-quickview]` elements rendered since the page loaded. The app
 * binds only once, on DOMContentLoaded, and skips elements it has already
 * bound. Calls in the same task are batched, so a grid of cards binds once.
 *
 * The app reads the `data-blm-*` values when it binds, not on click. An
 * element that morphs into another product's needs `data-force-update`, so
 * it's replaced and rebound rather than left with the old product's listener.
 */
export default function bindBloomreachEvents() {
  if (scheduled) return;
  scheduled = true;

  queueMicrotask(() => {
    scheduled = false;
    window.BloomreachModules?.productEvents?.load().catch(() => {});
  });
}
